// eslint-disable-next-line no-unused-vars

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      padding: theme.spacing(2),
    },
    searchFormControl: {},
    dialog: {
      minWidth: 500,
    },
    buttons: {
      justifyContent: 'space-between',
      padding: 20,
    },
    itemText: {
      textTransform: 'uppercase',
    },
    searchingBy: {
      fontSize: theme.spacing(2),
      color: 'rgba(0, 0, 0, 0.54)',
    },
    chipContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      paddingTop: 5,
    },
    chip: {
      margin: theme.spacing(0.5),
      marginLeft: 0,
      marginBottom: 5,
      fontSize: 14,
      fontWeight: 550,
    },
    message: {
      marginTop: theme.spacing(1),
      color: theme.palette.colors.blue,
    },
    hideDeleteIcon: {
      display: 'none',
    },
    chipAdd: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
      border: ' 2px dashed #14171A !important',
      '& span': {
        color: '#14171A',
      },
      cursor: 'pointer',
      '& svg': {
        background: ' #14171A',
        color: '#fff',
      },
    },
    classGroup: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
      border: ' 2px dashed #14171A',
      '& span': {
        color: '#14171A',
      },
      color: '#fff',
      cursor: 'pointer',
      '& svg': {
        background: ' #14171A',
        color: '#fff',
      },
    },
    deleteIcon: {
      width: 16,
      height: 16,
      background: theme.palette.primary.main,
      color: '#fff',
      borderRadius: '50%',

      '&:hover': {
        color: '#fff',
      },
    },
    chipLabel: {
      fontSize: theme.spacing(2),
      fontWeight: 500,
      color: theme.palette.colors.blue,
    },
    chipRoot: {
      minWidth: 150,
      justifyContent: 'space-between',
    },
    contentGroupings: {
      display: 'flex',
      width: 58,
      height: 35,
    },

    groupings: {
      height: 35,
      width: 35,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#F5F8FA',
      cursor: 'pointer',
      borderRadius: '50%',
    },
    badge: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 22,
      height: 22,
      fontSize: 13,
      borderRadius: '50%',
      background: '#EA9427',
      color: theme.palette.colors.white,
      position: 'relative',
      bottom: 6,
      right: 12,
    },
  }),
);

export default useStyles;
